import { CustomItemFormStructure, FormStructure } from '../components';
import { jsonPageSectionToStructure } from './structures';
import { jsonForm, jsonFormVisibilty, jsonSection, visibilityType } from './types/formTypes';

const visibilityMatch = (needle: visibilityType, haystack: jsonFormVisibilty) => {
    if (needle === 'BACK') {
        return true;
    }

    return haystack.length === 0 || haystack.includes(needle);
};

const jsonPageSectionsToStructure: (
    sections: jsonSection[],
    visibility: visibilityType,
    customItemRenderer: CustomItemFormStructure['renderField'],
) => FormStructure[] = (sections, visibility, customItemRenderer) =>
    sections
        .filter((section) =>
            visibilityMatch(visibility, (section?.visibility as jsonFormVisibilty) || []),
        )
        .map((section) => jsonPageSectionToStructure(section, customItemRenderer));

export const jsonPagesToStructure: (
    json: jsonForm,
    visibility: visibilityType,
    customItemRenderer: CustomItemFormStructure['renderField'],
) => Array<FormStructure[]> = (json, visibility, customItemRenderer) =>
    json.pages.map((page) =>
        jsonPageSectionsToStructure(page.sections, visibility, customItemRenderer),
    );

const jsonFormToFormStructure: (
    json: jsonForm,
    page: number,
    visibility: visibilityType,
    customItemRenderer: CustomItemFormStructure['renderField'],
) => FormStructure[] = (json, page, visibility, customItemRenderer) => {
    const structure: FormStructure[] = [];

    if (json.pages && json.pages[page] && json.pages[page].sections) {
        return jsonPageSectionsToStructure(
            json.pages[page].sections,
            visibility,
            customItemRenderer,
        );
    }

    return structure;
};

export const nestValueInBuffer = (buffer: Record<string, unknown>, key: string, value: unknown) => {
    const members = key.split('.');

    if (members.length > 1) {
        const newKey = members[0];
        // eslint-disable-next-line no-param-reassign
        buffer[newKey] = nestValueInBuffer(buffer[newKey] || {}, members.slice(1).join('.'), value);
    } else {
        // eslint-disable-next-line no-param-reassign
        buffer[key] = value;
    }

    return buffer;
};

export const jsonFormToDefaultValues = (json: jsonForm) => {
    const buffer = {};
    const pages = json.pages || [];
    pages
        .filter((page) => page?.sections !== undefined)
        .map((page) => page.sections)
        .flat()
        .filter((section) => section?.name !== undefined && section?.defaultvalue !== undefined)
        .forEach((section) => nestValueInBuffer(buffer, section.name, section.defaultvalue));

    return buffer;
};

export default jsonFormToFormStructure;
